/*
 * WobbleBag catalog behavior:
 * - <wb-quick-add>: variant picker dialog for multi-variant product cards. Content comes from
 *   sections/wobblebag-quick-add.liquid; the add itself goes through the theme's product-form.
 * - "Added" feedback on card buttons after a successful add (theme pub/sub cartUpdate event).
 * - <wb-load-more>: mobile "Load more" that appends the next native Shopify page.
 */
(function () {
  var ADDED_TIMEOUT = 2000;

  function announce(message) {
    var status = document.getElementById('WbCatalogStatus');
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 50);
  }

  function showAdded(button) {
    if (!button || !button.isConnected) return;
    var label = button.querySelector('[data-wb-btn-label]');
    if (!label) return;
    if (!button.dataset.wbOriginalLabel) button.dataset.wbOriginalLabel = label.textContent;
    button.classList.add('is-added');
    label.textContent = 'Added';
    window.clearTimeout(button._wbAddedTimer);
    button._wbAddedTimer = window.setTimeout(function () {
      button.classList.remove('is-added');
      label.textContent = button.dataset.wbOriginalLabel;
    }, ADDED_TIMEOUT);
  }

  if (!customElements.get('wb-quick-add')) {
    customElements.define(
      'wb-quick-add',
      class WbQuickAdd extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.dialog = this.querySelector('dialog');
          this.body = this.querySelector('[data-wb-qa-body]');
          this.placeholder = this.body.innerHTML;
          this.cache = {};

          this.querySelector('[data-wb-qa-close]').addEventListener('click', () => this.close());
          // Click on the backdrop (the dialog element itself, outside the panel) closes it.
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog.addEventListener('close', () => this.onClose());

          document.addEventListener('click', (event) => {
            var trigger = event.target.closest('[data-wb-quick-add]');
            if (!trigger) return;
            event.preventDefault();
            this.open(trigger);
          });

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            // Runs synchronously before the cart notification/drawer opens, so the dialog is
            // closed first and doesn't sit on top of the cart UI.
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (!this.dialog.open || event.source !== 'product-form') return;
              var idInput = this.body.querySelector('[data-wb-qa-id]');
              if (!idInput || String(event.productVariantId) !== idInput.value) return;
              var trigger = this.trigger;
              this.close();
              showAdded(trigger);
            });
          }
        }

        open(trigger) {
          this.trigger = trigger;
          this.body.innerHTML = this.placeholder;
          this.body.setAttribute('aria-busy', 'true');
          this.dialog.classList.add('is-loading');
          document.documentElement.classList.add('wb-scroll-lock');
          this.dialog.showModal();

          var url = trigger.dataset.productUrl;
          this.load(url)
            .then((html) => {
              if (this.trigger !== trigger || !this.dialog.open) return;
              this.body.innerHTML = html;
              this.body.removeAttribute('aria-busy');
              this.dialog.classList.remove('is-loading');
              this.initPicker();
              var firstField = this.body.querySelector('input[type="radio"]:checked, .wb-qa__submit');
              if (firstField) firstField.focus();
            })
            .catch(() => {
              // Fall back to the product page rather than leaving an empty dialog.
              window.location.href = url;
            });
        }

        load(url) {
          if (this.cache[url]) return Promise.resolve(this.cache[url]);
          var requestUrl = new URL(url, window.location.origin);
          requestUrl.searchParams.set('section_id', 'wobblebag-quick-add');
          return fetch(requestUrl.toString())
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              var content = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-wb-qa]');
              if (!content) throw new Error('Quick add content missing');
              this.cache[url] = content.outerHTML;
              return this.cache[url];
            });
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        onClose() {
          document.documentElement.classList.remove('wb-scroll-lock');
          this.body.innerHTML = this.placeholder;
          if (this.trigger && this.trigger.isConnected) this.trigger.focus();
        }

        initPicker() {
          var root = this.body.querySelector('[data-wb-qa]');
          var dataEl = root && root.querySelector('[data-wb-qa-variants]');
          if (!dataEl) return;
          this.variants = JSON.parse(dataEl.textContent);
          this.fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-wb-qa-option]'));
          root.addEventListener('change', (event) => {
            if (event.target.type === 'radio') this.update();
          });
          this.update();
        }

        selectedOptions() {
          return this.fieldsets.map(function (fieldset) {
            var checked = fieldset.querySelector('input:checked');
            return checked ? checked.value : null;
          });
        }

        update() {
          var selected = this.selectedOptions();
          var variant = this.variants.find(function (candidate) {
            return candidate.options.every(function (value, index) {
              return value === selected[index];
            });
          });
          if (!this.fieldsets.length) variant = this.variants[0];

          var idInput = this.body.querySelector('[data-wb-qa-id]');
          var submit = this.body.querySelector('[data-wb-qa-submit]');
          var label = submit.querySelector('[data-wb-btn-label]');

          idInput.value = variant ? variant.id : '';
          if (!variant) {
            submit.disabled = true;
            label.textContent = 'Unavailable';
          } else if (!variant.available) {
            submit.disabled = true;
            label.textContent = 'Sold out';
          } else {
            submit.disabled = false;
            label.textContent = 'Add to Cart';
          }

          this.renderPrice(variant || this.variants[0]);
          this.markAvailability(selected);

          var img = this.body.querySelector('.wb-qa__img');
          if (img && variant && variant.image) {
            img.removeAttribute('srcset');
            img.src = variant.image;
          }
        }

        renderPrice(variant) {
          var priceEl = this.body.querySelector('[data-wb-qa-price]');
          if (!priceEl || !variant) return;
          priceEl.textContent = '';
          var price = document.createElement('strong');
          price.textContent = variant.price;
          priceEl.appendChild(price);
          if (variant.compare) {
            var compare = document.createElement('s');
            compare.textContent = variant.compare;
            var discount = document.createElement('em');
            discount.textContent = variant.discount + '% OFF';
            priceEl.appendChild(compare);
            priceEl.appendChild(discount);
          }
        }

        // Dim values that can't be bought with the other current selections (still selectable).
        markAvailability(selected) {
          var variants = this.variants;
          this.fieldsets.forEach(function (fieldset, optionIndex) {
            fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
              var purchasable = variants.some(function (variant) {
                return (
                  variant.available &&
                  variant.options[optionIndex] === input.value &&
                  variant.options.every(function (value, index) {
                    return index === optionIndex || selected[index] === null || value === selected[index];
                  })
                );
              });
              input.closest('.wb-qa__value').classList.toggle('is-unavailable', !purchasable);
            });
          });
        }
      }
    );
  }

  // "Added" state for cards that add directly (single-variant products).
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;
      var variantId = String(event.productVariantId);
      document.querySelectorAll('.wb-product-card__form input[name="id"]').forEach(function (input) {
        if (input.value === variantId) showAdded(input.form.querySelector('[type="submit"]'));
      });
    });
  });

  if (!customElements.get('wb-load-more')) {
    customElements.define(
      'wb-load-more',
      class WbLoadMore extends HTMLElement {
        connectedCallback() {
          this.link = this.querySelector('a');
          if (!this.link || this._bound) return;
          this._bound = true;
          this.link.addEventListener('click', (event) => this.onClick(event));
        }

        onClick(event) {
          var grid = document.getElementById('product-grid');
          if (!grid) return;
          event.preventDefault();
          if (this.loading) return;
          this.loading = true;
          this.link.setAttribute('aria-disabled', 'true');
          this.link.classList.add('loading');
          var spinner = this.link.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var url = new URL(this.link.href, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);

          fetch(url.toString())
            .then(function (response) {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              var html = new DOMParser().parseFromString(text, 'text/html');
              var items = html.querySelectorAll('#product-grid > li');
              var firstNewIndex = grid.children.length;
              items.forEach(function (item) {
                grid.appendChild(document.importNode(item, true));
              });

              var next = html.querySelector('wb-load-more');
              if (next) {
                this.replaceWith(document.importNode(next, true));
              } else {
                this.remove();
              }

              announce(items.length + ' more products loaded');
              var firstNew = grid.children[firstNewIndex];
              var focusTarget = firstNew && firstNew.querySelector('.wb-product-card__title a');
              if (focusTarget) focusTarget.focus({ preventScroll: true });
            })
            .catch(() => {
              // Fall back to the regular paginated URL.
              window.location.href = this.link.href;
            });
        }
      }
    );
  }
})();
